import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { getUserPointsActivity } from '@/app/shared/services/api';
import { UserPointsActivityRow } from '@/app/shared/services/api/types';

export interface UseUserPointsActivityReturn {
  rows: UserPointsActivityRow[];
  isLoading: boolean;
  refetch: () => void;
}

export const useUserPointsActivity = (address?: string): UseUserPointsActivityReturn => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKeys.USER_POINTS_ACTIVITY, address],
    queryFn: () => getUserPointsActivity(address),
    enabled: !!address,
  });

  return {
    rows: data?.rows ?? [],
    isLoading,
    refetch,
  };
};
